<script>
import ParametresApi from '@/api/parametres';
import { required, withMessage, between, numeric, and } from 'form-validation-manager';
import ParametreInput from './parametre-input';
import { find } from 'lodash';
export default {
  name: 'Parametres',
  components: {
    ParametreInput
  },
  validations: {
    form: {
      HEURE_PIVOT: {
        value: and(
          withMessage(and(required(), numeric()), 'Valeur invalide'),
          withMessage(between(0, 23, false), 'Veuillez entrer une valeur comprise entre 0 et 23')
        )
      },
      DELAIS_HEURE_PIVOT: {
        value: withMessage(required(), 'Valeur invalide')
      },
      ECART_DATE_LIVR: {
        value: withMessage(required(), 'Valeur invalide')
      },
      TONNAGE_MAX_VISP: {
        value: withMessage((required(), numeric()), 'Valeur invalide')
      },
      TONNAGE_MAX_VIS: {
        value: withMessage((required(), numeric()), 'Valeur invalide')
      },
      TONNAGE_MAX_PNEUP: {
        value: withMessage((required(), numeric()), 'Valeur invalide')
      },
      TONNAGE_MAX_PNEU: {
        value: withMessage((required(), numeric()), 'Valeur invalide')
      },
      TONNAGE_MIN_BENNE: {
        value: withMessage((required(), numeric()), 'Valeur invalide')
      },
      TONNAGE_MAX_BENNE: {
        value: withMessage((required(), numeric()), 'Valeur invalide')
      },
      TONNAGE_MIN_FOND: {
        value: withMessage((required(), numeric()), 'Valeur invalide')
      },
      TONNAGE_MAX_FOND: {
        value: withMessage((required(), numeric()), 'Valeur invalide')
      },
      QUANTITE_MAX_MINERAUX: {
        value: withMessage((required(), numeric()), 'Valeur invalide')
      },
      DELAI_MESSAGE: {
        value: withMessage((required(), numeric()), 'Valeur invalide')
      },
      DELAI_LIVR_FOND: {
        value: withMessage((required(), numeric()), 'Valeur invalide')
      },
      DELAI_LIVR_BENNE: {
        value: withMessage((required(), numeric()), 'Valeur invalide')
      },
      DELAIS_COMMANDE_MAX: {
        value: withMessage(required(), 'Valeur invalide')
      },
      DELAIS_ALERTE_COMMANDE: {
        value: withMessage(required(), 'Valeur invalide')
      }
    }
  },
  data: () => ({
    loading: true,
    form: {
      section_heure_pivot: {
        libelle: 'Heure pivot de commande',
        type: 'section'
      },
      HEURE_PIVOT: {
        key: 'SAS-HORAIRE_COMMANDE-HEURE_PIVOT',
        type: 'Integer',
        libelle: 'Heure pivot de commande',
        aide: true,
        param: {},
        get value () { return this.param.value !== undefined ? parseInt(this.param.value.split(':')[0]) : null; },
        set value (val) { this.param.value = (val + '').padStart(2, '0') + ':00:00'; },
        edition: false
      },
      DELAIS_HEURE_PIVOT: {
        key: 'SAS-HORAIRE_COMMANDE-DELAIS_HEURE_PIVOT',
        type: 'periode',
        format: 'hm',
        libelle: 'Délai heure pivot de commande',
        aide: true,
        param: {},
        get value () { return this.param.value; },
        set value (val) { this.param.value = val; },
        edition: false
      },
      section_contraintes_dates: {
        libelle: 'Dates de livraison',
        type: 'section'
      },
      ECART_DATE_LIVR: {
        key: 'SAS-DELAIS_COMMANDE-ECART_DATE',
        type: 'periode',
        format: 'd',
        libelle: 'Ecart maxi entre les deux dates de livraison',
        aide: true,
        param: {},
        get value () { return this.param.value; },
        set value (val) { this.param.value = val; },
        edition: false
      },
      DELAIS_COMMANDE_MAX: {
        key: 'SAS-DELAIS_COMMANDE-DELAIS_MAX',
        type: 'periode',
        format: 'Mwd',
        libelle: 'Commande au plus tard',
        aide: true,
        param: {},
        get value () { return this.param.value; },
        set value (val) { this.param.value = val; },
        edition: false
      },
      DELAIS_ALERTE_COMMANDE: {
        key: 'SAS-DELAIS_COMMANDE-DELAIS_ALERTE',
        type: 'periode',
        format: 'd',
        libelle: 'Délai d \'alerte',
        aide: true,
        param: {},
        get value () { return this.param.value; },
        set value (val) { this.param.value = val; },
        edition: false
      },
      section_camions: {
        libelle: 'Contraintes camions',
        type: 'section'
      },
      TONNAGE_MAX_VIS: {
        key: 'SAS-MODE_CAMION_QTE-VIS_MAX',
        type: 'Integer',
        libelle: 'Tonnages camion',
        soustitre: 'MAXI      Vis ',
        aide: true,
        param: {},
        get value () { return this.param.value !== undefined ? parseInt(this.param.value) : null; },
        set value (val) { this.param.value = val; },
        edition: false
      },
      TONNAGE_MAX_VISP: {
        key: 'SAS-MODE_CAMION_QTE-VISP_MAX',
        type: 'Integer',
        libelle: null,
        soustitre: 'MAXI      Petit camion Vis ',
        aide: false,
        param: {},
        get value () { return this.param.value !== undefined ? parseInt(this.param.value) : null; },
        set value (val) { this.param.value = val; },
        edition: false
      },
      TONNAGE_MAX_PNEU: {
        key: 'SAS-MODE_CAMION_QTE-PNEU_MAX',
        type: 'Integer',
        libelle: '',
        soustitre: 'MAXI      Camion Soufflerie ',
        param: {},
        get value () { return this.param.value !== undefined ? parseInt(this.param.value) : null; },
        set value (val) { this.param.value = val; },
        edition: false
      },
      TONNAGE_MAX_PNEUP: {
        key: 'SAS-MODE_CAMION_QTE-PNEUP_MAX',
        type: 'Integer',
        libelle: '',
        soustitre: 'MAXI      Petit camion Soufflerie ',
        aide: false,
        param: {},
        get value () { return this.param.value !== undefined ? parseInt(this.param.value) : null; },
        set value (val) { this.param.value = val; },
        edition: false
      },
      TONNAGE_MIN_BENNE: {
        key: 'SAS-MODE_CAMION_QTE-BENNE_MIN',
        type: 'Integer',
        libelle: '',
        soustitre: 'MINI      Camion Benne',
        aide: false,
        param: {},
        get value () { return this.param.value !== undefined ? parseInt(this.param.value) : null; },
        set value (val) { this.param.value = val; },
        edition: false
      },
      TONNAGE_MAX_BENNE: {
        key: 'SAS-MODE_CAMION_QTE-BENNE_MAX',
        type: 'Integer',
        libelle: '',
        soustitre: 'MAXI      Camion Benne',
        aide: false,
        param: {},
        get value () { return this.param.value !== undefined ? parseInt(this.param.value) : null; },
        set value (val) { this.param.value = val; },
        edition: false
      },
      TONNAGE_MIN_FOND: {
        key: 'SAS-MODE_CAMION_QTE-FOND_MIN',
        type: 'Integer',
        libelle: '',
        soustitre: 'MINI      Camion Fond mouvant',
        aide: false,
        param: {},
        get value () { return this.param.value !== undefined ? parseInt(this.param.value) : null; },
        set value (val) { this.param.value = val; },
        edition: false
      },
      TONNAGE_MAX_FOND: {
        key: 'SAS-MODE_CAMION_QTE-FOND_MAX',
        type: 'Integer',
        libelle: '',
        soustitre: 'MAXI      Camion Fond mouvant',
        aide: false,
        param: {},
        get value () { return this.param.value !== undefined ? parseInt(this.param.value) : null; },
        set value (val) { this.param.value = val; },
        edition: false
      },
      DELAI_LIVR_FOND: {
        key: 'SAS-MODE_CAMION_DELAI_LIVR-FOND',
        type: 'Integer',
        libelle: 'Délai de livraison ',
        soustitre: 'Fond mouvant',
        aide: true,
        param: {},
        get value () { return this.param.value !== undefined ? parseInt(this.param.value) : null; },
        set value (val) { this.param.value = val; },
        edition: false
      },
      DELAI_LIVR_BENNE: {
        key: 'SAS-MODE_CAMION_DELAI_LIVR-BENNE',
        type: 'Integer',
        libelle: '',
        soustitre: 'Benne',
        aide: false,
        param: {},
        get value () { return this.param.value !== undefined ? parseInt(this.param.value) : null; },
        set value (val) { this.param.value = val; },
        edition: false
      },
      section_incorporation: {
        libelle: 'Incorporation',
        type: 'section'
      },
      QUANTITE_MAX_MINERAUX: {
        key: 'SAS-COMMANDE_QTE-QTE_MAX_MINERAL',
        type: 'Integer',
        libelle: 'Minéral en incorporation',
        soustitre: '',
        aide: true,
        param: {},
        get value () { return this.param.value !== undefined ? parseInt(this.param.value) : null; },
        set value (val) { this.param.value = val; },
        edition: false
      },
      section_messages: {
        libelle: 'Bannière de message',
        type: 'section'
      },
      DELAI_MESSAGE: {
        key: 'CDE-PARAMS_APPLI-DELAI_ALERTE_FERIES',
        type: 'Integer',
        libelle: 'Affichage de la bannière jour férié',
        soustitre: '',
        aide: true,
        param: {},
        get value () { return this.param.value !== undefined ? parseInt(this.param.value) : null; },
        set value (val) { this.param.value = val; },
        edition: false
      }

    }
  }),
  created () {
    Promise.all([
      ParametresApi.getAllParametres().then(
        params => {
          for (const param of params) {
            const formItem = find(this.form, { key: `SAS-${param.categorie}-${param.code}` });
            if (formItem) {
              formItem.param = param;
            }
          }
        }
      ),
      ParametresApi.getAllParamAppli().then(
        params => {
          for (const param of params) {
            const formItem = find(this.form, { key: `CDE-${param.categorie}-${param.code}` });
            if (formItem) {
              formItem.param = param;
            }
          }
        }
      )
    ]).finally(() => { this.loading = false; });
  },
  methods: {

    submit () {

    },
    edit (item) {
      item.edition = true;
      Object.defineProperty(item, '__original_value', { configurable: true, writable: true, value: item.value });
    },
    cancel (item) {
      item.value = item.__original_value;
      item.edition = false;
      this.$forceUpdate();
    },
    save (item) {
      if (item.value === item.__original_value) {
        this.cancel(item);
      } else {
        this.loading = true;

        item.edition = false;

        if (item.key.substring(0, 3) === 'SAS') {
          ParametresApi.modifierParametre(item.param)
            .catch(err => {
              this.cancel(item);
              throw err;
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          ParametresApi.modifParamAppli(item.param)
            .catch(err => {
              this.cancel(item);
              throw err;
            })
            .finally(() => {
              this.loading = false;
            });
        }
      }
    }
  }
};
</script>

<template>
  <div class="content">
    <h1>Gestion des paramètres</h1>
    <Loader v-if="loading" />
    <v-form
      v-else
      ref="form"
      @submit.prevent="submit"
    >
      <table class="params-list">
        <tr
          v-for="(item,index) in form"
          :key="item.key"
        >
          <template v-if="item.type === 'section'">
            <td colspan="4">
              <h3>{{ item.libelle }}</h3>
            </td>
          </template>
          <template v-else>
            <td class="pl-8">
              <CardsHelp
                v-if="item.aide"
                :page="item.key"
                :niveau="'SOUS-TITRE'"
              />
              {{ item.libelle }}
            </td>
            <td>{{ item.soustitre }}</td>

            <td>
              <ParametreInput
                v-model="item.value"
                :format="item.format"
                class="p-input"
                :type="item.type"
                :disabled="!item.edition"
                :errors="$fvm.form[index].$errors"
              />
            </td>
            <td>
              <v-btn
                v-if="item.edition"
                outlined
                @click="cancel(item)"
              >
                Annuler
                <v-icon>mdi-undo</v-icon>
              </v-btn>
              <v-btn
                v-else
                @click="edit(item)"
              >
                Modifier
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                :disabled="!item.edition || $fvm.form[index].$invalid"
                @click="save(item)"
              >
                Enregister
                <v-icon>mdi-content-save</v-icon>
              </v-btn>
            </td>
          </template>
        </tr>
      </table>
    </v-form>
  </div>
</template>

<style lang="scss" scoped>
.params-list {
  td {
    // vertical-align: text-bottom;
    padding-right: 2em;
  }

  .p-input {
    min-width: 200px;
  }
}

.v-btn .v-icon {
  margin-left: 0.3em;
}

.catalog-content {
  margin: 2vw;
  padding: 1vw;
  background-color: #f4f8f9;
}

@import "~vuetify/src/styles/settings/_variables";
@media #{map-get($display-breakpoints, 'xs-only')} {
  .params-list {
    tr {
      display: flex;
      flex-direction: column;

      td:last-child {
        margin-left: auto;
      }
    }

    .p-input {
      width: 100%;
    }
  }
}
</style>
